<svg:g [attr.transform]="trace.translate" [style.opacity]="trace.visible ? 1 : 0" class="trace">
    <!-- TITLE -->
    <text
        [attr.y]="25"
        [style.fill]="trace.appearance.color"
        [style.opacity]="trace.title.visible ? 1 : 0"
        class="title"
    >
        {{ trace.title.text }}
    </text>

    <!-- SAMPLES -->
    <path
        [attr.d]="trace.samples"
        [style.stroke-width]="trace.appearance.highlight ? 0.2 : 0.1"
        [style.stroke]="trace.appearance.color"
        id="ecgpath"
    ></path>

    <!-- FIDUCIAL POINTS -->
    <path
        *ngFor="let fiducialPoint of trace.fiducialPoints"
        [attr.d]="fiducialPoint.marker"
        [style.opacity]="trace.layout.ecgState.chartState.fiducialPointsVisible ? 1 : 0"
    ></path>

    <g
        [color]="trace.appearance.color"
        [highlight]="trace.appearance.highlight"
        [path]="trace.step.path"
        [titleY]="trace.step.titleY"
        [title]="trace.step.title"
        trace-step
    ></g>

    <rect
        [attr.height]="3"
        [attr.width]="trace.layout.context.leadWidth"
        [attr.x]="0"
        [attr.y]="trace.layout.context.leadHeight / 2 - 1.5"
        class="optionsBand"
        id="bandOptions"
    ></rect>

    <g
        (measuresChange)="onMeasuresChange($event)"
        (removeCaliper)="onRemoveCaliper($event)"
        *ngFor="let caliper of trace.calipers"
        [caliper]="caliper"
        trace-caliper
    ></g>
</svg:g>
